module.exports = __webpack_public_path__ + "static/media/industria-2.593eaae8.jpg";